import { useEffect, useState } from 'react';
import { signOut } from 'next-auth/react';

import { api } from '@/features/Auth/api';

import { request } from '@/utils/request';

export const useSessionTakeover = () => {
  const [isSessionTakenOver, setIsSessionTakenOver] = useState(false);

  useEffect(() => {
    request.onSessionTakeover(() => {
      setIsSessionTakenOver(true);
      signOut({ redirect: false });
    });

    return () => {
      request.onSessionTakeover(null);
    };
  }, []);

  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState !== 'visible') {
        return;
      }

      if (isSessionTakenOver) {
        return;
      }

      if (!request.isAuthorizationTokenSet()) {
        return;
      }

      try {
        const { data } = await api.getSessionStatus();

        if (!data.sessionValid) {
          setIsSessionTakenOver(true);
          request.removeTokens();
          signOut({ redirect: false });
        }
      } catch {
        // Silently ignore — if 401, the interceptor handles it
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isSessionTakenOver]);

  const handleRedirectToLogin = () => {
    window.location.href = '/login';
  };

  const handleResetPassword = () => {
    window.location.href = '/forgot-password';
  };

  return {
    isSessionTakenOver,
    handleRedirectToLogin,
    handleResetPassword,
  };
};
